var React = require('react');

function IconLinkedin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"cls-1","d":"M16.67 0H1.33A1.31 1.31 0 0 0 0 1.3v15.4A1.31 1.31 0 0 0 1.33 18h15.34A1.32 1.32 0 0 0 18 16.7V1.3A1.32 1.32 0 0 0 16.67 0zM5.34 15.34H2.67V6.75h2.67zM4 5.57A1.55 1.55 0 1 1 5.55 4 1.55 1.55 0 0 1 4 5.57zm11.34 9.77h-2.67v-4.18c0-1 0-2.28-1.39-2.28s-1.6 1.12-1.6 2.21v4.25H7V6.75h2.57v1.17a2.82 2.82 0 0 1 2.52-1.38c2.71 0 3.21 1.77 3.21 4.09zM21.66 13.88a.58.58 0 0 0 .58-.61c0-.42-.26-.63-.79-.63h-.86v2.25h.32v-1h.41l.62 1h.34l-.66-1zm-.37-.22h-.38v-.77h.48c.24 0 .53 0 .53.37s-.29.4-.63.4z","key":0}),React.createElement("path",{"className":"cls-1","d":"M21.33 11.64a2.13 2.13 0 1 0 2.13 2.13 2.11 2.11 0 0 0-2.13-2.13zm0 4a1.85 1.85 0 1 1 1.81-1.85 1.81 1.81 0 0 1-1.81 1.83z","key":1})]);
}

IconLinkedin.defaultProps = {"viewBox":"0 0 23.46 18"};

module.exports = IconLinkedin;

IconLinkedin.default = IconLinkedin;
